import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import DeckCollectionHelper from './DeckCollectionHelper'

const FlyoutDeckPrice = ({ deckCards, deckSlug, priceSource }) => (
	<StyledToolbarFlyout>
		<DeckCollectionHelper
			flyout
			type="priceBreakdown"
			deckCards={deckCards}
			deckSlug={deckSlug}
			priceSource={priceSource}
		/>
	</StyledToolbarFlyout>
)

FlyoutDeckPrice.propTypes = {
	deckCards: PropTypes.array.isRequired,
	deckSlug: PropTypes.string.isRequired,
	priceSource: PropTypes.number.isRequired
}

const StyledToolbarFlyout = styled.div`
	padding: 0;
`

export default FlyoutDeckPrice
